/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 */

(function (M, _, $, Backbone) {
  "use strict";

  M.View = M.View || {};
  M.View.Design = M.View.Design || {};

  /**
   * @class M.View.Design.PollEnd
   * Displays a dialog with a number of options on which design version
   * will replace this poll.
   */
  M.View.Design.PollEnd = Backbone.View.extend({
    tagName: 'div',
    className: 'pollEndDialog',
    events: {
      'click .cancel': 'close',
      'submit form': 'endPoll'
    },

    template: M.Template.Design.PollEnd,

    initialize: function() {
      this.$el = $(this.el);
      this.designVersionOptions = [{
        label: 'current version',
        value: 'current_version'
      }].concat(this.getOptionRadios());
    },

    /**
     * Makes an object for each poll option that will be a radio box for
     * selecting that option to be the next design version. The option with
     * the highest number of votes will be checked by default.
     *
     * @return {Array} The option objects.
     */
    getOptionRadios: function () {
      var bestOption,
          options = [];
      _.each(this.options.optionViews, function (option) {
        option = {
          name: option.name,
          votes: option.votes,
          value: option.model.id
        };
        if (!bestOption) {
          bestOption = option;
        } else if (option.votes.vote_count > bestOption.votes.vote_count) {
          bestOption = option;
        }
        options.push(option);
      });
      bestOption.checked = true;
      return options;
    },

    render: function() {
      this.$el.html(this.template(this));
      this.$el.dialog({
        title: 'What design version should replace your poll?',
        modal: true,
        width: 500,
        draggable: false,
        closeText: '',
      });
      return this;
    },

    /**
     * Gets the user-selected option for what will become the next design
     * version and sends that information to the server to create the
     * new version accordingly. When this new version is created, the poll
     * is effectively ended.
     */
    endPoll: function (e) {
      e.preventDefault();
      var versionOption = this.$('input[type=radio]:checked').val();
      this.model.end(versionOption, {
        success: function () {
          location.reload();
        }
      });
    },

    close: function(e) {
      if (e) {
        e.preventDefault();
      }
      this.$el.dialog('close');
    }
  });

})(M, _, $, Backbone);


